import { BuiltInExteriorPropId } from "building-types/props/builtInExteriorPropId";
import { PropCategory } from "building-types/props/propCategoryTypes";
import { PropId } from "building-types/props/propIds";
import type { PropAttributes } from "building-types/props/propTypes";
import { propCatalogItemNew } from "doc/propTools";

export const defaultExteriorPropCatalog: { [key in BuiltInExteriorPropId]: PropAttributes } = {
  garageDoorSingle: propCatalogItemNew({
    id: BuiltInExteriorPropId.GARAGEDOORSINGLE,
    name: "garageDoorSingle",
    propAssetId: PropId.DoorGar_S8x7_2x4_01,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  garageDoorSingleSecondary: propCatalogItemNew({
    id: BuiltInExteriorPropId.GARAGEDOORSINGLESECONDARY,
    name: "garageDoorSingleSecondary",
    propAssetId: PropId.DoorGar_S8x7_4x3Pattern_2Lite4th_H_01,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  garageDoorDouble: propCatalogItemNew({
    id: BuiltInExteriorPropId.GARAGEDOORDOUBLE,
    name: "garageDoorDouble",
    propAssetId: PropId.DoorGar_D16x7_2x4_01,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  garageDoorDoubleSecondary: propCatalogItemNew({
    id: BuiltInExteriorPropId.GARAGEDOORDOUBLESECONDARY,
    name: "garageDoorDoubleSecondary",
    propAssetId: PropId.DoorGar_D16x7_4x3Pattern_2Lite4th_H_01,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  garageDoorDoubleTertiary: propCatalogItemNew({
    id: BuiltInExteriorPropId.GARAGEDOORDOUBLETERTIARY,
    name: "garageDoorDoubleTertiary",
    propAssetId: PropId.DoorGar_D16x7_4x3Pattern_2Lite4th_H_01,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  garageDoorDoubleQuaternary: propCatalogItemNew({
    id: BuiltInExteriorPropId.GARAGEDOORDOUBLEQUATERNARY,
    name: "garageDoorDoubleQuaternary",
    propAssetId: PropId.DoorGar_D16x7_4x3Pattern_2Lite4th_H_01,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  doorGarage10080: propCatalogItemNew({
    id: BuiltInExteriorPropId.DOORGARAGE10080,
    name: "doorGarage10080",
    propAssetId: PropId.DoorGar_S10x8_2x1Pattern_1Lite3rdCross_01,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  doorGarage20080: propCatalogItemNew({
    id: BuiltInExteriorPropId.DOORGARAGE20080,
    name: "doorGarage20080",
    propAssetId: PropId.DoorGar_D20x8_2x1Pattern_1Lite3rdCross_01,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  doorGarage18070: propCatalogItemNew({
    id: BuiltInExteriorPropId.DOORGARAGE18070,
    name: "doorGarage18070",
    propAssetId: PropId.DoorGar_D18x7_2x4_01,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  doorGarage18070Secondary: propCatalogItemNew({
    id: BuiltInExteriorPropId.DOORGARAGE18070SECONDARY,
    name: "doorGarage18070Secondary",
    propAssetId: PropId.DoorGar_D18x7_2x3x2Pattern_4Lite4th_01,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  doorGarage9070: propCatalogItemNew({
    id: BuiltInExteriorPropId.DOORGARAGE9070,
    name: "doorGarage9070",
    propAssetId: PropId.DoorGar_S9x7_2x4_01,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  sedan: propCatalogItemNew({
    id: BuiltInExteriorPropId.SEDAN,
    name: "sedan",
    propAssetId: PropId.Garage_Car_Sedan_01,
    category: PropCategory.FURNITURE,
    useExteriorPalette: true,
  }),
  suv: propCatalogItemNew({
    id: BuiltInExteriorPropId.SUV,
    name: "suv",
    propAssetId: PropId.Garage_SUV_Crossover_01,
    category: PropCategory.FURNITURE,
    useExteriorPalette: true,
  }),
  truck: propCatalogItemNew({
    id: BuiltInExteriorPropId.TRUCK,
    name: "truck",
    propAssetId: PropId.Garage_Truck_Pickup_01,
    category: PropCategory.FURNITURE,
    useExteriorPalette: true,
  }),
  doorSingleGlass32: propCatalogItemNew({
    id: BuiltInExteriorPropId.DOORSINGLEGLASS32,
    name: "doorSingleGlass32",
    propAssetId: PropId.DoorExt_Single32_02,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  doorSingleGlass32HL: propCatalogItemNew({
    id: BuiltInExteriorPropId.DOORSINGLEGLASS32HL,
    name: "doorSingleGlass32HL",
    propAssetId: PropId.DoorExt_Single32_Half1_02,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  doorSingleGlass32Low: propCatalogItemNew({
    id: BuiltInExteriorPropId.DOORSINGLEGLASS32LOW,
    name: "doorSingleGlass32Low",
    propAssetId: PropId.DoorExt_Single32_01,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  doorSingleGlass32LowHL: propCatalogItemNew({
    id: BuiltInExteriorPropId.DOORSINGLEGLASS32LOWHL,
    name: "doorSingleGlass32LowHL",
    propAssetId: PropId.DoorExt_Single32_Half1_01,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  doorSingleGlass36HL: propCatalogItemNew({
    id: BuiltInExteriorPropId.DOORSINGLEGLASS36HL,
    name: "doorSingleGlass36HL",
    propAssetId: PropId.DoorExt_Single36_Half1_02,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  doorSingleGlass36LowHL: propCatalogItemNew({
    id: BuiltInExteriorPropId.DOORSINGLEGLASS36LOWHL,
    name: "doorSingleGlass36LowHL",
    propAssetId: PropId.DoorExt_Single36_Half1_01,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  doorSingleGlassSecondary: propCatalogItemNew({
    id: BuiltInExteriorPropId.DOORSINGLEGLASSSECONDARY,
    name: "doorSingleGlassSecondary",
    propAssetId: PropId.DoorExt_Single36_02,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  doorSingleGlassLowSecondary: propCatalogItemNew({
    id: BuiltInExteriorPropId.DOORSINGLEGLASSLOWSECONDARY,
    name: "doorSingleGlassLowSecondary",
    propAssetId: PropId.DoorExt_Single36_01,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  doorDoubleGlass: propCatalogItemNew({
    id: BuiltInExteriorPropId.DOORDOUBLEGLASS,
    name: "doorDoubleGlass",
    propAssetId: PropId.DoorExt_Double30_02,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  doorSlidingGlass4068: propCatalogItemNew({
    id: BuiltInExteriorPropId.DOORSLIDINGGLASS4068,
    name: "doorSlidingGlass4068",
    propAssetId: PropId.DoorExt_Sliding48_Glass_01,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  doorSlidingGlass4080: propCatalogItemNew({
    id: BuiltInExteriorPropId.DOORSLIDINGGLASS4080,
    name: "doorSlidingGlass4080",
    propAssetId: PropId.DoorExt_Sliding48_Glass_02,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  doorSlidingGlass5068: propCatalogItemNew({
    id: BuiltInExteriorPropId.DOORSLIDINGGLASS5068,
    name: "doorSlidingGlass5068",
    propAssetId: PropId.DoorExt_Sliding60_Glass_01,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  doorSlidingGlass5080: propCatalogItemNew({
    id: BuiltInExteriorPropId.DOORSLIDINGGLASS5080,
    name: "doorSlidingGlass5080",
    propAssetId: PropId.DoorExt_Sliding60_Glass_02,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  doorSlidingGlass6068: propCatalogItemNew({
    id: BuiltInExteriorPropId.DOORSLIDINGGLASS6068,
    name: "doorSlidingGlass6068",
    propAssetId: PropId.DoorExt_Sliding72_Glass_01,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  doorSlidingGlass6080: propCatalogItemNew({
    id: BuiltInExteriorPropId.DOORSLIDINGGLASS6080,
    name: "doorSlidingGlass6080",
    propAssetId: PropId.DoorExt_Sliding72_Glass_02,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  doorSlidingGlass7680: propCatalogItemNew({
    id: BuiltInExteriorPropId.DOORSLIDINGGLASS7680,
    name: "doorSlidingGlass7680",
    propAssetId: PropId.DoorExt_Sliding90_Glass_02,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  doorSlidingGlass7880: propCatalogItemNew({
    id: BuiltInExteriorPropId.DOORSLIDINGGLASS7880,
    name: "doorSlidingGlass7880",
    propAssetId: PropId.DoorExt_Sliding92_Glass_02,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  doorSlidingGlass8080: propCatalogItemNew({
    id: BuiltInExteriorPropId.DOORSLIDINGGLASS8080,
    name: "doorSlidingGlass8080",
    propAssetId: PropId.DoorExt_Sliding96_Glass_02,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  doorSlidingGlass9068: propCatalogItemNew({
    id: BuiltInExteriorPropId.DOORSLIDINGGLASS9068,
    name: "doorSlidingGlass9068",
    propAssetId: PropId.DoorExt_Sliding108_Glass_01,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  doorSlidingGlass9080: propCatalogItemNew({
    id: BuiltInExteriorPropId.DOORSLIDINGGLASS9080,
    name: "doorSlidingGlass9080",
    propAssetId: PropId.DoorExt_Sliding108_Glass_02,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  doorSlidingGlass10068: propCatalogItemNew({
    id: BuiltInExteriorPropId.DOORSLIDINGGLASS10068,
    name: "doorSlidingGlass10068",
    propAssetId: PropId.DoorExt_Sliding120x2_Glass4_01,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  doorSlidingGlass10080: propCatalogItemNew({
    id: BuiltInExteriorPropId.DOORSLIDINGGLASS10080,
    name: "doorSlidingGlass10080",
    propAssetId: PropId.DoorExt_Sliding120x2_Glass4_02,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  doorSlidingGlass12080: propCatalogItemNew({
    id: BuiltInExteriorPropId.DOORSLIDINGGLASS12080,
    name: "doorSlidingGlass12080",
    propAssetId: PropId.DoorExt_Sliding120x2_Glass4_02,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  doorSlidingGlass15068: propCatalogItemNew({
    id: BuiltInExteriorPropId.DOORSLIDINGGLASS15068,
    name: "doorSlidingGlass15068",
    propAssetId: PropId.DoorExt_Sliding180_Glass3_01,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  doorSlidingGlass15080: propCatalogItemNew({
    id: BuiltInExteriorPropId.DOORSLIDINGGLASS15080,
    name: "doorSlidingGlass15080",
    propAssetId: PropId.DoorExt_Sliding180_Glass3_02,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  doorDoubleGlassLow: propCatalogItemNew({
    id: BuiltInExteriorPropId.DOORDOUBLEGLASSLOW,
    name: "doorDoubleGlassLow",
    propAssetId: PropId.DoorExt_Double30_01,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  doorDoubleGlass36Low: propCatalogItemNew({
    id: BuiltInExteriorPropId.DOORDOUBLEGLASS36LOW,
    name: "doorDoubleGlass36Low",
    propAssetId: PropId.DoorExt_Double36_01,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  doorDoubleGlass36LowHingedFixed: propCatalogItemNew({
    id: BuiltInExteriorPropId.DOORDOUBLEGLASS36LOWHINGEDFIXED,
    name: "doorDoubleGlass36LowHingedFixed",
    propAssetId: PropId.DoorExt_Double36_HingedFixed_01,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  doorDoubleGlass36HingedFixed: propCatalogItemNew({
    id: BuiltInExteriorPropId.DOORDOUBLEGLASS36HINGEDFIXED,
    name: "doorDoubleGlass36HingedFixed",
    propAssetId: PropId.DoorExt_Double36_HingedFixed_02,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  doorDoubleSlide: propCatalogItemNew({
    id: BuiltInExteriorPropId.DOORDOUBLESLIDE,
    name: "doorDoubleSlide",
    propAssetId: PropId.DoorExt_Sliding60_Glass_02,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  doorDoubleSlideLow: propCatalogItemNew({
    id: BuiltInExteriorPropId.DOORDOUBLESLIDELOW,
    name: "doorDoubleSlideLow",
    propAssetId: PropId.DoorExt_Sliding60_Glass_01,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  doorSingleGlass: propCatalogItemNew({
    id: BuiltInExteriorPropId.DOORSINGLEGLASS,
    name: "doorSingleGlass",
    propAssetId: PropId.DoorExt_Single36_02,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  doorSingleGlass36: propCatalogItemNew({
    id: BuiltInExteriorPropId.DOORSINGLEGLASS36,
    name: "doorSingleGlass36",
    propAssetId: PropId.DoorExt_Single42_Plank_02,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  doorSingleGlassLow: propCatalogItemNew({
    id: BuiltInExteriorPropId.DOORSINGLEGLASSLOW,
    name: "doorSingleGlassLow",
    propAssetId: PropId.DoorExt_Single36_01,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  doorSingleGlassLowTransom: propCatalogItemNew({
    id: BuiltInExteriorPropId.DOORSINGLEGLASSLOWTRANSOM,
    name: "doorSingleGlassLowTransom",
    propAssetId: PropId.Arch_Elliott_FakeDoorTransom_01,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  exteriorLamp: propCatalogItemNew({
    id: BuiltInExteriorPropId.EXTERIORLAMP,
    name: "exteriorLamp",
    propAssetId: PropId.Lights_ExteriorWall_LanternTall_01,
    showOnElevationsAndPerspectives: true,
    category: PropCategory.FIXTURES,
    useExteriorPalette: true,
  }),
  deckSet: propCatalogItemNew({
    id: BuiltInExteriorPropId.DECKSET,
    name: "deckSet",
    propAssetId: PropId.Deck_Dine_6LongUmbrella_01,
    category: PropCategory.FURNITURE,
    useExteriorPalette: true,
  }),
  deckChairSingle: propCatalogItemNew({
    id: BuiltInExteriorPropId.DECKCHAIRSINGLE,
    name: "deckChairSingle",
    propAssetId: PropId.Deck_Seat_Single_01,
    category: PropCategory.FURNITURE,
    useExteriorPalette: true,
  }),
  deckChair: propCatalogItemNew({
    id: BuiltInExteriorPropId.DECKCHAIR,
    name: "deckChair",
    propAssetId: PropId.Deck_Seat_Rocking_01,
    category: PropCategory.FURNITURE,
    useExteriorPalette: true,
  }),
  chairAdirondack: propCatalogItemNew({
    id: BuiltInExteriorPropId.CHAIRADIRONDACK,
    name: "chairAdirondack",
    propAssetId: PropId.Deck_Seat_Adirondack_01,
    category: PropCategory.FURNITURE,
    useExteriorPalette: true,
  }),
  deckBench: propCatalogItemNew({
    id: BuiltInExteriorPropId.DECKBENCH,
    name: "deckBench",
    propAssetId: PropId.Deck_Seat_Bench_01,
    category: PropCategory.FURNITURE,
    useExteriorPalette: true,
  }),
  deckSideTable: propCatalogItemNew({
    id: BuiltInExteriorPropId.DECKSIDETABLE,
    name: "deckSideTable",
    propAssetId: PropId.Deck_Table_Side_01,
    category: PropCategory.FURNITURE,
    useExteriorPalette: true,
  }),
  deckCoffeeTable: propCatalogItemNew({
    id: BuiltInExteriorPropId.DECKCOFFEETABLE,
    name: "deckCoffeeTable",
    propAssetId: PropId.Living_Table_Coffee_01,
    category: PropCategory.FURNITURE,
    useExteriorPalette: true,
  }),
  deckDiningTable4Seat: propCatalogItemNew({
    id: BuiltInExteriorPropId.DECKDININGTABLE4SEAT,
    name: "deckDiningTable4Seat",
    propAssetId: PropId.Deck_Dine_4Square_01,
    category: PropCategory.FURNITURE,
    useExteriorPalette: true,
  }),
  deckDiningTable6Seat: propCatalogItemNew({
    id: BuiltInExteriorPropId.DECKDININGTABLE6SEAT,
    name: "deckDiningTable6Seat",
    propAssetId: PropId.Deck_Dine_6Long_01,
    category: PropCategory.FURNITURE,
    useExteriorPalette: true,
  }),
  grillGas: propCatalogItemNew({
    id: BuiltInExteriorPropId.GRILLGAS,
    name: "grillGas",
    propAssetId: PropId.Deck_Grill_Gas_01,
    showOnElevationsAndPerspectives: true,
    isElectricalArchitecturalProp: true,
    useExteriorPalette: true,
  }),
  grillInsert: propCatalogItemNew({
    id: BuiltInExteriorPropId.GRILLINSERT,
    name: "grillInsert",
    propAssetId: PropId.Deck_Grill_GasInsert_01,
    floorPlanTag: "GAS",
    showOnElevationsAndPerspectives: true,
    isElectricalArchitecturalProp: true,
    useExteriorPalette: true,
  }),
  outdoorFridge: propCatalogItemNew({
    id: BuiltInExteriorPropId.OUTDOORFRIDGE,
    name: "outdoorFridge",
    propAssetId: PropId.Kitchen_FridgeMini24_Single_01,
    showOnElevationsAndPerspectives: true,
    isPlumbingArchitecturalProp: true,
    category: PropCategory.APPLIANCES,
    useExteriorPalette: true,
  }),
  sink: propCatalogItemNew({
    id: BuiltInExteriorPropId.SINK,
    name: "sink",
    propAssetId: PropId.Kitchen_Sink30_Single_01,
    showOnElevationsAndPerspectives: true,
    isPlumbingArchitecturalProp: true,
    defaultVerticalOffset: 36,
    category: PropCategory.FIXTURES,
    useExteriorPalette: true,
  }),
  firepit: propCatalogItemNew({
    id: BuiltInExteriorPropId.FIREPIT,
    name: "firepit",
    propAssetId: PropId.Deck_Firepit_Round_01,
    showOnElevationsAndPerspectives: true,
    category: PropCategory.FURNITURE,
    useExteriorPalette: true,
  }),
  rakeBracket: propCatalogItemNew({
    id: BuiltInExteriorPropId.RAKEBRACKET,
    name: "rakeBracket",
    propAssetId: PropId.Arch_BracketLegacy_16_01,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  angleBracket14x18: propCatalogItemNew({
    id: BuiltInExteriorPropId.ANGLEBRACKET14X18,
    name: "angleBracket14x18",
    propAssetId: PropId.Arch_BracketAngledPost_14x18_01,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  angleBracket25x27: propCatalogItemNew({
    id: BuiltInExteriorPropId.ANGLEBRACKET25X27,
    name: "angleBracket25x27",
    propAssetId: PropId.Arch_BracketFypon_BKT25x27_01,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  angleBracket20x20: propCatalogItemNew({
    id: BuiltInExteriorPropId.ANGLEBRACKET20X20,
    name: "angleBracket20x20",
    propAssetId: PropId.Arch_BracketFypon_BKT20x20_01,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  soffitCorbel8x12: propCatalogItemNew({
    id: BuiltInExteriorPropId.SOFFITCORBEL8X12,
    name: "soffitCorbel8x12",
    propAssetId: PropId.Arch_SoffitCorbel_08x12_01,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  awningBracket: propCatalogItemNew({
    id: BuiltInExteriorPropId.AWNINGBRACKET,
    name: "awningBracket",
    propAssetId: PropId.Arch_BracketFypon_BKT25x27_01,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  bracketFrenchCountry: propCatalogItemNew({
    id: BuiltInExteriorPropId.BRACKETFRENCHCOUNTRY,
    name: "bracketFrenchCountry",
    propAssetId: PropId.Arch_BracketLegacy_16_01,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  bracketTallTapered: propCatalogItemNew({
    id: BuiltInExteriorPropId.BRACKETTALLTAPERED,
    name: "bracketTallTapered",
    propAssetId: PropId.Arch_BracketFlair_29_01,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  ceilingFan: propCatalogItemNew({
    id: BuiltInExteriorPropId.CEILINGFAN,
    name: "ceilingFan",
    propAssetId: PropId.Lights_InteriorCeiling_52fan5_01,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  craftColumn: propCatalogItemNew({
    id: BuiltInExteriorPropId.CRAFTCOLUMN,
    name: "craftColumn",
    propAssetId: PropId.Arch_Column120_Modern_01,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  craftOrnament: propCatalogItemNew({
    id: BuiltInExteriorPropId.CRAFTORNAMENT,
    name: "craftOrnament",
    propAssetId: PropId.Arch_MercerPalm_GableDetail_01,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  beazerOrnament: propCatalogItemNew({
    id: BuiltInExteriorPropId.BEAZERORNAMENT,
    name: "beazerOrnament",
    propAssetId: PropId.Arch_ArmstrongACL_GableDetail_01,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  shutters3050: propCatalogItemNew({
    id: BuiltInExteriorPropId.SHUTTERS3050,
    name: "shutters3050",
    propAssetId: PropId.Arch_Layne_FakeShutter36x60_01,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  doorSingleArch36: propCatalogItemNew({
    id: BuiltInExteriorPropId.DOORSINGLEARCH36,
    name: "doorSingleArch36",
    propAssetId: PropId.DoorExt_Single42_ArcQuarter1Iron_02,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  exteriorLampGas: propCatalogItemNew({
    id: BuiltInExteriorPropId.EXTERIORLAMPGAS,
    name: "exteriorLampGas",
    propAssetId: PropId.Lights_ExteriorWall_LanternFixed_01,
    floorPlanTag: "GAS",
    showOnElevationsAndPerspectives: true,
    isElectricalArchitecturalProp: true,
    category: PropCategory.FIXTURES,
    useExteriorPalette: true,
  }),
  zenColumn: propCatalogItemNew({
    id: BuiltInExteriorPropId.ZENCOLUMN,
    name: "zenColumn",
    propAssetId: PropId.Arch_Column_ZenStraight_01,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  zenColumnAngled: propCatalogItemNew({
    id: BuiltInExteriorPropId.ZENCOLUMNANGLED,
    name: "zenColumnAngled",
    propAssetId: PropId.Arch_Column_ZenAnglePair_01,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  craftShutter: propCatalogItemNew({
    id: BuiltInExteriorPropId.CRAFTSHUTTER,
    name: "craftShutter",
    propAssetId: PropId.Arch_Layne_FakeShutter36x60_01,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  elliottGableArch12: propCatalogItemNew({
    id: BuiltInExteriorPropId.ELLIOTTGABLEARCH12,
    name: "elliottGableArch12",
    propAssetId: PropId.Arch_GableDetailArc_p12o12_01,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  elliottGableArch7: propCatalogItemNew({
    id: BuiltInExteriorPropId.ELLIOTTGABLEARCH7,
    name: "elliottGableArch7",
    propAssetId: PropId.Arch_GableDetailArc_p07o12_01,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  elliottGableArch8: propCatalogItemNew({
    id: BuiltInExteriorPropId.ELLIOTTGABLEARCH8,
    name: "elliottGableArch8",
    propAssetId: PropId.Arch_GableDetailArc_p08o12_01,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  elliottGableArch9: propCatalogItemNew({
    id: BuiltInExteriorPropId.ELLIOTTGABLEARCH9,
    name: "elliottGableArch9",
    propAssetId: PropId.Arch_GableDetailArc_p09o12_01,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
};
